<template>
  <common-template>
    <template v-slot:body>
      <div v-if="isReady" class="wrapper">
        <div id="regist-wrapper">

          <member-regist-form
            v-show="pages === 'form'"
            :preflist="preflist"
            :limitedPrefList="limitedPrefList"
            @updated="slideView"
          />

          <member-regist-confirm
            v-if="pages === 'confirm'"
            :args="args"
            @updated="slideView"
          />

          <member-regist-complete v-if="pages === 'complete'" />

        </div>
      </div>
    </template>
  </common-template>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';

import Meta from '@/assets/json/meta.json';
import MixinAPI from '@/plugins/mixin-api';

import MemberRegistForm from '@/components/member/regist/MemberRegistForm';
import MemberRegistConfirm from '@/components/member/regist/MemberRegistConfirm';
import MemberRegistComplete from '@/components/member/regist/MemberRegistComplete';

import CommonTemplate from '@/components/templates/CommonTemplate';

export default {
  name: 'Regist',
  components: {
    MemberRegistForm,
    MemberRegistConfirm,
    MemberRegistComplete,
    CommonTemplate,
  },
  data() {
    return {
      pages: 'form',
      args: [],
      isReady: false,
      preflist: [],
      limitedPrefList: [],
    };
  },
  created() {
    if (!(this.$route.query.code && this.$route.query.email)) {
      this.$router.replace({ path: '/member/signup', query: this.$route.query });
    } else {
      this.isReady = true;
      // Footer表示フラグ更新
      this.$store.commit('setFooterDisplayFlag');
    }
  },
  async mounted() {
    document.querySelector('meta[name="description"]').setAttribute('content', Meta.default.description);
    this.preflist = await this.getPrefectureList();
    this.limitedPrefList = await this.getPrefectureList(1);
  },
  watch: {
    pages: {
      immediate: true,
      handler(newValue) {
        switch (newValue) {
          case 'form':
            document.title = `ご登録情報入力｜${Meta.default.title}`;
            break;
          case 'confirm':
            document.title = `ご入力内容確認｜${Meta.default.title}`;
            break;
          case 'complete':
            document.title = `ご登録完了｜${Meta.default.title}`;
            break;
          default:
            document.title = Meta.default.title;
        }
      },
    },
  },
  mixins: [IsMobileMixin, MixinAPI],
  methods: {
    slideView(nextView, args = []) {
      this.pages = nextView;
      this.args = args;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@charset "UTF-8";
@media screen and (max-width: 1199px) {
  @import "../../assets/style/glocal_scss_sp.scss";
  @import "../../assets/style/parts_scss_sp.scss";
}
@media screen and (min-width: 1200px) {
  @import "../../assets/style/glocal_scss_pc.scss";
  @import "../../assets/style/parts_scss_pc.scss";
  body {
    margin: 0;
  }
}
@import "../../assets/style/parts_responsive.scss";

.wrapper {
  height: 100%;
}

#regist-wrapper {
    background-color: #fafafa;
}

@media screen and (min-width: 640px) {
  #regist-wrapper {
    padding: 30px 15px;
    margin: auto;
  }
}

@media (min-width: 1000px) {
  #regist-wrapper {
    width: 100%;
  }

  #profile-change-wrapper {
    padding: 20px;

    #profile-change-inner-wrapper {
      width: 800px;
    }
  }

  #profile-change-form {
    .profile-change-field {

      label {
        width: 40%;
      }
      .input-wrapper {
        width: 60%;
        #address-select-wrapper {
          width: 100%;
        }

        &.name-input-wrapper {
          .inner-input-wrapper {
            flex: 1;
          }
          .top-margin {
            margin-top: 0;
            margin-left: 8px;
          }
        }
      }
      #desired-rent-input-wrapper {
        width: 60%;
      }
    }
  }

  .inner-input-wrapper {
    width: 100%;
    flex: 1;
  }

  .inner-input-wrapper-fullscreen-short {
    width: 48%;
  }
}

</style>
